import { socialLinkResp, socialUnlinkResp } from '@biz-models/network/login-authenticate-network.model';
import { createActionGroup } from '@ngrx/store';

export const socialLinkAccount = createActionGroup({
	source: 'Social Account ',
	events: {
		SocialLinkSuccess: (payload: socialLinkResp) => ({ payload }),
		SocialLinkFail: (payload: Error) => ({ payload }),

		SocialUnlinkSuccess: (payload: socialUnlinkResp) => ({ payload }),
		SocialUnlinkFail: (payload: string) => ({ payload }),
	},
});
